import URLRoutes from "./routes";
import "./App.css";

function App() {
  return (
    <div>
      <URLRoutes />
    </div>
  );
}

export default App;